import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetCalculatorErrors, setCalculatorValues } from 'shared/redux/landingSlice';
import { selectCalculatorDefaultValues } from 'shared/selectors/landing';
import { ICalculatorMcfValues } from 'shared/types/features';

export const useResetCalculatorFilters = () => {
  const dispatch = useDispatch();
  const calculatorDefaultValues = useSelector(selectCalculatorDefaultValues);

  return useCallback(() => {
    if (!calculatorDefaultValues) {
      return;
    }

    const resetValues = calculatorDefaultValues as ICalculatorMcfValues;

    dispatch(setCalculatorValues(resetValues));
    dispatch(resetCalculatorErrors());
  }, [calculatorDefaultValues, dispatch]);
};
